export default __webpack_public_path__ + "static/media/remove_white.d1028299.svg";